import React from 'react';

interface Props {
  id: string;
}

export const CarrierMap = ({ id, }:Props) => {
  return (
    <div>
      mapa { id }
    </div>
  );
};
